// extracted by mini-css-extract-plugin
export default {"ctaLabel":"UnlockableInfoModalCtaLabel_ctaLabel__nuhaY"};